import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Panel } from '@/components/Panel';

const SIZES = ['XS','S','M','L','XL','XXL'];
const EXTRAS = ['Bucket Hat','Extra Socks','Mystery Box','Secret Release Item'];

export default function DesignMyCollection() {
  const [colourways, setColourways] = useState([]);
  const [sel, setSel] = useState({
    tracksuit_1_color: '',
    tracksuit_2_color: '',
    tracksuit_size: 'M',
    extras: [],
    founder_hoodie_color: '',
  });
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    (async () => {
      const [c, b] = await Promise.all([api.get('/colourways'), api.get('/founders/bundle')]);
      setColourways(c.data.colourways || []);
      const current = b.data.selections || {};
      setSel(s => ({ ...s, ...current, extras: current.extras || [] }));
    })();
  }, []);

  const toggleExtra = (e) => setSel(s => ({ ...s, extras: s.extras.includes(e) ? s.extras.filter(x => x !== e) : [...s.extras, e] }));

  const save = async () => {
    setSaved(false);
    await api.post('/founders/design', sel);
    setSaved(true);
    setTimeout(() => setSaved(false), 2200);
  };

  const Swatch = ({ value, active, onClick }) => (
    <button onClick={onClick} className={`flex items-center gap-2 p-2 pr-3 rounded-full border ${active ? 'shadow-panel' : ''}`}
            style={{ borderColor: active ? 'var(--heritage-plum)' : 'rgba(75,24,56,0.25)', background: active ? '#FBF8F1' : 'transparent' }}
            data-testid={`swatch-${value.name}`}>
      <span className="w-6 h-6 rounded-full" style={{ background: value.hex }} />
      <span className="text-xs" style={{ color: 'var(--heritage-plum)' }}>{value.name}</span>
    </button>
  );

  return (
    <div className="space-y-6">
      <Panel className="p-8">
        <div className="h-eyebrow">Design My Collection</div>
        <div className="h-display text-4xl mt-1" style={{ color: 'var(--heritage-plum)' }}>Choose your founder pieces</div>
      </Panel>

      <Panel className="p-6">
        <div className="h-eyebrow mb-3">Tracksuit 1 colour</div>
        <div className="flex flex-wrap gap-2">
          {colourways.filter(c => !c.tier_restricted).map(c => (
            <Swatch key={c.id} value={c} active={sel.tracksuit_1_color === c.name} onClick={() => setSel({ ...sel, tracksuit_1_color: c.name })} />
          ))}
        </div>
      </Panel>

      <Panel className="p-6">
        <div className="h-eyebrow mb-3">Tracksuit 2 colour</div>
        <div className="flex flex-wrap gap-2">
          {colourways.filter(c => !c.tier_restricted).map(c => (
            <Swatch key={c.id} value={c} active={sel.tracksuit_2_color === c.name} onClick={() => setSel({ ...sel, tracksuit_2_color: c.name })} />
          ))}
        </div>
      </Panel>

      <Panel className="p-6">
        <div className="h-eyebrow mb-3">Size</div>
        <div className="flex flex-wrap gap-2">
          {SIZES.map(s => (
            <button key={s} onClick={() => setSel({ ...sel, tracksuit_size: s })}
              className={`px-4 py-2 rounded-full text-sm border ${sel.tracksuit_size === s ? '' : 'opacity-80'}`}
              style={{ borderColor: 'var(--heritage-plum)', background: sel.tracksuit_size === s ? 'var(--heritage-plum)' : 'transparent', color: sel.tracksuit_size === s ? 'var(--heritage-cream)' : 'var(--heritage-plum)' }}
              data-testid={`size-${s}`}
            >{s}</button>
          ))}
        </div>
      </Panel>

      <Panel className="p-6">
        <div className="h-eyebrow mb-3">Extras</div>
        <div className="grid md:grid-cols-2 gap-2">
          {EXTRAS.map(e => (
            <label key={e} className="flex items-center gap-3 p-3 rounded-lg cursor-pointer"
                   style={{ background: sel.extras.includes(e) ? 'rgba(143,163,75,0.15)' : 'rgba(75,24,56,0.04)', border: '1px solid rgba(75,24,56,0.15)' }}>
              <input type="checkbox" checked={sel.extras.includes(e)} onChange={() => toggleExtra(e)} />
              <span className="text-sm" style={{ color: 'var(--heritage-plum)' }}>{e}</span>
            </label>
          ))}
        </div>
      </Panel>

      <div className="flex gap-3 items-center">
        <button className="h-btn" onClick={save} data-testid="design-save">Save Changes</button>
        {saved && <div className="h-eyebrow" style={{ color: '#5B6E2C' }}>Saved</div>}
      </div>
    </div>
  );
}
